<template>
  <div>
    <page-header :title="$t('bill.budget')" />
    <page-body>
      <budget-list id="BudgetList" />
    </page-body>
  </div>
</template>

<script>
import BudgetList from './components/List'

export default {
  name: 'BillBudget',
  components: {
    BudgetList,
  },
}
</script>
